const isProd = process.env.NODE_ENV === 'production';

type APIConfig = {
  baseUrl: string;
  timeout: number;
  enableApiDelay?: boolean;
  delay?: number;
};

const devAPIconf = {
  baseUrl: 'http://localhost:3888/api',
  enableApiDelay: true,
  timeout: 10000,
  delay: 1000,
};

// TODO - UPDATE PRODUCTION API
const prodAPIconf = {
  baseUrl: 'https://api.communikit.ca/api',
  enableApiDelay: false,
  timeout: 30000,
};

const apiConf: APIConfig = isProd ? prodAPIconf : devAPIconf;

export { apiConf };
